const route = {
	path: '/statistics',
	name: 'statistics',
	meta: {
		title: 'Estadisticas',
	},
	component: () => import('@/pages/statistics/page-statistics'),
	props: true,
};

export default route;



// WEBPACK FOOTER //
// ./src/router/statistics.js